import type { GlobalConfig } from '../@types/context/global-config.types';
import type { MyPageConfig } from '../@types/context/my-page-config.types';
import type { ProductUnsecuredLoanConfig } from '../@types/context/product-unsecured-loan-config.types';
import type { SiteConfig } from '../@types/context/site-config.types';
import { contactZmartaSeConfig } from './presets/contact-zmarta-se.config';
import { globalSe } from './presets/global-se.config';
import { myPageOffersConfig } from './presets/mypage-offers.config';
import { organisationZmartaSeConfig } from './presets/organisation-zmarta-se.config';
import { serviceTrustpilotAxoConfig } from './presets/service-trustpilot-axo.config';
import { sitePathZmartaSeConfig } from './presets/site-path-zmarta-se.config';
import { unsecuredLoansBrokerCustomFields } from './presets/unsecured-loans-broker-custom-fields.config';

export const global: GlobalConfig = {
  brand: 'freedomfinance.se',
  ...globalSe,
};

export const site: SiteConfig = {
  domain: 'freedomfinance.se',
  name: 'Freedom Finance',
  theme: {
    name: 'freedom-finans',
    brand: 'freedom-finance',
  },
  ...sitePathZmartaSeConfig,
  ...organisationZmartaSeConfig,
  ...contactZmartaSeConfig,
  services: {
    trustpilot: {
      ...serviceTrustpilotAxoConfig,
      // businessUnitId: '4ebbb9350000640005117dc0', // freedomfinance trustpilot id fails to fetch data
      businessUnitId: '53f1ed8a000064000579aff2', // use zmarta.se instead
    },
    gtm: 'GTM-K48RWG24',
    ga: 'G-TZ0ZPQC264',
  },
};

export const productUnsecuredLoan: ProductUnsecuredLoanConfig = {
  fields: unsecuredLoansBrokerCustomFields,
};

export const myPage: MyPageConfig = {
  options: { hasHighCostWarning: true, ...myPageOffersConfig },
};
